import { isObject } from "./validation/index.mjs";
export var Element;

(function (Element) {
  function isElement(value, type) {
    if (isObject(value) && typeof value.type === 'string') {
      return type === undefined || value.type === type;
    }

    return false;
  }

  Element.isElement = isElement;
})(Element || (Element = {}));